module.exports = __webpack_public_path__ + "static/media/who_we_are_img.ae98cc3e.webp";